import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { NewMemoUrl } from '../../../shared/urls/newmemo.url';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
@Injectable()
export class ManageMemoMyTMBService {
    
    constructor(public baseService: BaseService) { }
    
    getMyTMBMemo() {
        const url = MasterDataUrl.GET_MYTMB_MEMO;
        return this.baseService.get(url);
    }

    updateMemo(data) {
        const url = MasterDataUrl.UPDATE_MYTMB_MEMO;
        return this.baseService.update(url, data);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/manage-memo-mytmb/manage-memo-mytmb.service.ts